import '@divkitframework/divkit/dist/client.css';
import './styles.css';
import { render } from 'solid-js/web';
import App from './App';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Application root was not found');
}

render(() => <App />, root);
